export default {
    list: { method: 'get', url: 'produtos' },
    ativo: { method: 'get', url: 'produtos/ativo' }
}
